import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { Caption, CardBox, CardTitle } from './styles';
import { Cell, Muted } from './tableStyles';
import SectionState from '../shared/SectionState';
import { channelLabel } from '../shared/labels';

import ROUTES from '@/routes/routes';
import { TransactionalMessage } from '@/services/lifecycleAPI';
import styled from '@/styles';

const COLUMNS = 'minmax(220px, 1fr) minmax(260px, 1.3fr) 160px 100px';

const Line = styled('div', {
  display: 'grid',
  gridTemplateColumns: COLUMNS,
  gap: '12px',
  padding: '10px 20px',
  borderTop: '1px solid #F0F0F0',
  minWidth: '780px',
  alignItems: 'center',
  fontSize: '14px',
});

const Toggle = styled('button', {
  font: 'inherit',
  width: '100%',
  background: 'none',
  border: 'none',
  padding: '16px 20px',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  cursor: 'pointer',
  textAlign: 'left',
  '& svg': { transition: 'transform 0.15s' },
  '&[aria-expanded="true"] svg': { transform: 'rotate(90deg)' },
});

type Props = { messages: TransactionalMessage[] };

const TransactionalCard = ({ messages }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <CardBox data-testid="transactionalCard">
      <Toggle
        aria-expanded={open}
        type="button"
        onClick={() => setOpen((value) => !value)}
      >
        <FontAwesomeIcon icon={faChevronRight} />
        <CardTitle as="span">
          Transactional messages ({messages.length})
        </CardTitle>
        <Caption>
          Not part of journeys. They follow consent only, so there are no
          switches.
        </Caption>
      </Toggle>
      {open &&
        (messages.length === 0 ? (
          <SectionState
            caption="Transactional messages appear here once they are set up."
            mode="empty"
            title="No transactional messages"
          />
        ) : (
          <div style={{ overflowX: 'auto', borderTop: '1px solid #EDEDED' }}>
            <Line
              style={{
                background: '#FAFAFA',
                fontSize: 12,
                fontWeight: 600,
                color: '#5A5A5A',
                textTransform: 'uppercase',
                borderTop: 'none',
              }}
            >
              <span>Message</span>
              <span>Sent when</span>
              <span>Channels</span>
              <span />
            </Line>
            {messages.map((message) => (
              <Line key={message.step_key}>
                <Cell css={{ gap: '2px' }}>
                  <strong style={{ fontWeight: 600 }}>{message.label}</strong>
                  <Muted>{message.step_key}</Muted>
                </Cell>
                <span>{message.trigger}</span>
                <Muted style={{ color: '#3D3D3D' }}>
                  {message.channels.map(channelLabel).join(', ')}
                </Muted>
                {/* Legal text is not in the copy editor: a link would open
                    a "Not found" editor (review D-07). */}
                {message.editable === false ? (
                  <Muted style={{ fontSize: 13 }}>Fixed text (legal)</Muted>
                ) : (
                  <Link
                    style={{ fontSize: 13, fontWeight: 600, color: '#1E8E3E' }}
                    to={`/${ROUTES.lifecycle}?tab=copy&message=${message.step_key}`}
                  >
                    Edit copy
                  </Link>
                )}
              </Line>
            ))}
          </div>
        ))}
    </CardBox>
  );
};

export default TransactionalCard;
